import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "guan-board"
};
var _hoisted_2 = {
  key: 0,
  class: "check__loading"
};
var _hoisted_3 = {
  class: "guan-board-tab"
};
var _hoisted_4 = {
  class: "guan-board-content"
};
import { computed, ref, onMounted } from 'vue';
import { getUserMenuPermission } from '@/api/index-guan';
import WujieVue from 'wujie-vue3';
import SubTab from '../../Components/SubTab.vue';
import InteractiveData from './InteractiveData.vue';
import TeacherContribute from './TeacherContribute.vue';
import ClassGroup from './ClassGroup.vue';
import ResourceConstruction from './ResourceConstruction.vue';
import CoursePublish from './CoursePublish.vue';
import ParentsBind from './ParentsBind.vue';
import StudentGrow from './StudentGrow.vue';
import StudentResource from './StudentResource.vue';
import AppView from './AppView.vue';
import LessonUnlinkIn from './LessonUnlinkIn.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var tabs = [{
      name: '互动数据',
      value: 1,
      component: InteractiveData,
      key: '/interactiveData',
      exist: true
    }, {
      name: '教师贡献',
      value: 2,
      component: TeacherContribute,
      key: '/teacherContribute',
      exist: true
    }, {
      name: '班级分组',
      value: 3,
      component: ClassGroup,
      key: '/sectionedClass',
      exist: true
    }, {
      name: '资源建设',
      value: 4,
      component: ResourceConstruction,
      key: '/resourceConstruction',
      exist: true
    }, {
      name: '学程发布情况',
      value: 5,
      component: CoursePublish,
      key: '/publishCourseStat',
      exist: true
    }, {
      name: '家长绑定情况',
      value: 6,
      component: ParentsBind,
      key: '/parentsBind',
      exist: true
    }, {
      name: '学生成长数据看板',
      value: 7,
      component: StudentGrow,
      key: '/studentGrow',
      exist: true
    }, {
      name: '学生资源学习看板',
      value: 8,
      component: StudentResource,
      key: '/studentResourcesDashboard',
      exist: true
    }, {
      name: '应用访问数据看板',
      value: 9,
      component: AppView,
      key: '/usageFrequency',
      exist: true
    }, {
      name: '未入课堂数据分析',
      value: 10,
      component: LessonUnlinkIn,
      key: '/lessonUnlinkIn',
      exist: true
    }];
    var checking = ref(true);
    var activeTabs = ref([]);
    var auths = ref([]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _yield$getUserMenuPer, data, _ref2, userIsGod, result, memberStatus, userStatus, menus, auth, hasAuths, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            checking.value = true;
            _context.n = 1;
            return getUserMenuPermission();
          case 1:
            _yield$getUserMenuPer = _context.v;
            data = _yield$getUserMenuPer.data;
            _ref2 = (data === null || data === void 0 ? void 0 : data.data) || {}, userIsGod = _ref2.userIsGod, result = _ref2.result, memberStatus = _ref2.memberStatus, userStatus = _ref2.userStatus, menus = _ref2.menus, auth = _ref2.auth;
            hasAuths = userIsGod || result === 'access' && memberStatus === 0 && userStatus === 0;
            auths.value = auth;
            console.log('设置后的auth值:', auths.value); // 确认值已设置
            activeTabs.value = menus === null || menus === void 0 ? void 0 : menus.map(function (item) {
              // 在 tabs 中查找与当前 data item 的 permissionKey 匹配的项
              var matchedTab = tabs.find(function (tab) {
                return tab.key === item.path;
              });

              // 如果找到匹配项，合并数据；否则返回原始 data item
              return matchedTab ? _objectSpread(_objectSpread(_objectSpread({}, item), {
                hasAppAuth: hasAuths
              }), matchedTab) // 展开合并两个对象
              : item; // 无匹配时返回原数据
            });
            console.log('activeTabs:', activeTabs.value);
            bus.$emit('show-enter-data-view', hasAuths);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.log(_t);
          case 3:
            _context.p = 3;
            checking.value = false;
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    })));
    var defaultIndex = ref(1);
    var domRef = ref(null);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [checking.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[0] || (_cache[0] = _createElementVNode("span", null, "权限校验中...", -1))])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(SubTab, {
        tabs: activeTabs.value,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["tabs", "default-index"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        auth: auths.value,
        ref_key: "domRef",
        ref: domRef
      }, null, 8, ["auth"]))])], 64))]);
    };
  }
};